var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tsd-container"}},[_c('div',[_c('Header')],1),(this.loginType === 'simpleLogin')?_c('div',[_c('SimpleLoginComponent')],1):_vm._e(),(this.loginType === 'odi')?_c('div',[_c('ODIComponent')],1):_vm._e(),(this.loginType === 'calnet')?_c('div',[_c('CalnetLoginComponent')],1):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }